import React, { FC } from 'react';
import { Div, Span } from '@kizi/core-components';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const pulseKeyframe = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  90% {
    opacity: 1;
  }
`;

const PulsatingPath = styled(Span)`
  animation: ${pulseKeyframe} 2s infinite;
`;

export interface SkeletonBlockProps {
  width?: number | string;
  height?: number | string;
  marginBottom?: number | string;
  marginRight?: number | string;
  color?: string;
}
export interface SkeletonWrapperProps {
  isMobile?: boolean;
  padding?: number | string;
  marginBottom?: number | string;
  width?: number | string;
  height?: number | string;
  direction?: 'column' | 'row';
}
export const SkeletonBlock: FC<SkeletonBlockProps> = ({
  width = 105,
  height = 30,
  marginBottom = 0,
  marginRight = 0,
  color = '#F2F2F0',
}) => (
  <PulsatingPath
    backgroundColor={color}
    height={height}
    width={width}
    marginBottom={marginBottom}
    marginRight={marginRight}
    display="block"
  />
);

export const SkeletonWrapper: FC<SkeletonWrapperProps> = ({
  children,
  isMobile = false,
  marginBottom = 20,
  padding = '15px',
  width = '100%',
  height = 'auto',
  direction = 'row',
}) => {
  return (
    <Div
      display={isMobile ? ['flex', null, 'none'] : ['none', null, 'flex']}
      flexDirection={direction}
      padding={padding}
      marginBottom={marginBottom}
      height={height}
      width={width}
      borderRadius={10}
      alignItems="center"
      boxShadow="0px 0px 20px rgba(0, 0, 0, 0.15)"
      backgroundColor="#FFFFFF"
      justifyContent={isMobile ? 'unset' : 'space-between'}
      style={{ boxSizing: 'border-box' }}
    >
      {children}
    </Div>
  );
};
